var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.dropdownClasses,
      attrs: {
        role: "combobox",
        tabindex: "0",
        "aria-label": _vm.label + ": " + _vm.currentOptionLabel,
        "aria-expanded": _vm.isOpened.toString(),
        "aria-haspopup": "listbox",
      },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.onToggle.apply(null, arguments)
        },
        keydown: _vm.onToggleKeydown,
      },
    },
    [
      _vm.label
        ? _c("div", { staticClass: "trbo-a-dropdown__label" }, [
            _vm._v(_vm._s(_vm.label) + ":"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currentOptionLabel
        ? _c("div", { staticClass: "trbo-a-dropdown__current-value" }, [
            _vm._v(_vm._s(_vm.currentOptionLabel)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "trbo-a-dropdown__arrow" },
        [_c("vertical-arrow")],
        1
      ),
      _vm._v(" "),
      _vm.isOpened
        ? _c(
            "div",
            {
              staticClass: "trbo-a-dropdown__options",
              attrs: { role: "listbox" },
            },
            _vm._l(_vm.options, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  ref: "dropdownOptions",
                  refInFor: true,
                  class: _vm.optionItemClasses(item),
                  attrs: {
                    role: "option",
                    tabindex: "0",
                    "aria-selected": _vm.value === item.value,
                    "data-text": item.label,
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onSelect(item)
                    },
                    keydown: function (event) {
                      return _vm.onSelectKeydown(event, item)
                    },
                  },
                },
                [_vm._v("\n      " + _vm._s(item.label) + "\n    ")]
              )
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }